import {Route} from "../../registry/routes.js"
// import binsDisplay from "../../components/mediaQC/qcWorkspace.vue"
import binsDisplay from "../../components/bins/BinsDisplay.vue";
// import binsDisplay from "../../components/PAM/ProjectsMain.vue";
// import binsDisplay from "../../components/editPro/editProProjects.vue"
// import binsDisplay from "../../components/PAM/TicketsWorkspace.vue"

const r = new Route("bins-display", "files", {"bins-display":binsDisplay}, {componentType:"main_component", title: "Files"}, [], true, null)

export default r